import { render } from "./Hue.vue?vue&type=template&id=10b6ad22"
import script from "./Hue.vue?vue&type=script&lang=js"
export * from "./Hue.vue?vue&type=script&lang=js"

import "./Hue.vue?vue&type=style&index=0&id=10b6ad22&lang=css"
script.render = render

export default script